<div class="d-flex justify-content-between align-items-center mb-4">
  <span class="h4 m-0">
    {{lang == 'en' ? 'Edit Profile': ' تعديل الصفحه الشخصيه  '}}
  </span>
  <button mat-button routerLink="..">
    <img
      src="../../../../assets/icons/back-icon.svg"
      title="Back Button"
      width="40"
    />
  </button>
</div>

<form [formGroup]="profileForm">
  <div class="row">
    <mat-form-field class="col-12 ">
      <mat-label>
        {{ lang == 'en' ? 'First Name': 'الاسم الاول'}}
      </mat-label>
      <input matInput title="First Name" formControlName="firstName">
      <div *ngIf="profileForm.get('firstName')?.invalid && profileForm.get('firstName')?.touched" class="errorMsgForm">
        {{ getFirstNameErrorMessage(profileForm.get('firstName')!, lang) }}
      </div>
    </mat-form-field>

    <mat-form-field class="col-12">
      <mat-label>
        {{lang == 'en' ? 'Last Name':'الاسم الاخير'}}
      </mat-label>
      <input matInput title="Last Name" formControlName="lastName">
      <div *ngIf="profileForm.get('lastName')?.invalid && profileForm.get('lastName')?.touched" class="errorMsgForm">
        {{ getLastNameErrorMessage(profileForm.get('lastName')!, lang) }}
      </div>
    </mat-form-field>

    <!-- <mat-form-field class="col-12">
      <mat-label>
        {{lang == 'en' ? 'Phone':'رقم الهاتف '}}
      </mat-label>
      <input matInput title="Phone" formControlName="userPhoneNumber" numbersOnly type="text">
      <div *ngIf="profileForm.get('userPhoneNumber')?.invalid && profileForm.get('userPhoneNumber')?.touched" class="errorMsgForm">
        {{ getPhoneErrorMessage(profileForm.get('userPhoneNumber')!, lang) }}
      </div>
    </mat-form-field> -->
    
    <div class="custom-ngx-intl-tel-input col-12 mb-2">
      <ngx-intl-tel-input
        [cssClass]="'phone'"
        [preferredCountries]="['eg','us', 'gb']"
        [enableAutoCountrySelect]="true"
        [enablePlaceholder]="true"
        [searchCountryFlag]="true"
        [selectFirstCountry]="false"
        [selectedCountryISO]="CountryISO.Egypt"
        [phoneValidation]="false"
        formControlName="userPhoneNumber">
      </ngx-intl-tel-input>
      <div *ngIf="profileForm.get('userPhoneNumber')?.invalid && profileForm.get('userPhoneNumber')?.touched" class="error-message">
        {{ getPhoneErrorMessage(profileForm.get('userPhoneNumber')!, lang) }}
      </div>
    </div>


  


  </div>

  <div class="input-style col-12">
    <p>
      {{lang == 'en' ? 'Email':'الايميل '}}
    </p>
    <p>{{email}}</p>
  </div>

  <button
    (click)="onSubmit()"
    class="submitBtn btnColor"
    mat-raised-button
    color="primary"
    [disabled]="isLoading || !profileForm.dirty"
  >
    <mat-spinner
      *ngIf="isLoading"
      diameter="20"
      color="primary"
    ></mat-spinner>

    <span *ngIf="!isLoading">
      {{lang == 'en' ? 'Edit Profile': ' تعديل الصفحه الشخصيه  '}}
    </span>
  </button>
</form>

<form [formGroup]="changePasswordForm">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{lang == 'en' ? 'Change Password':'تغير كلمة المرور'}}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-form-field class="col-12">
      <mat-label>
        {{lang == 'en' ? 'Old Password':'كلمة المرور القديمة '}}
      </mat-label>
      <input matInput title="Old Password" type="password" formControlName="oldPassword">
      <div *ngIf="changePasswordForm.get('oldPassword')?.invalid && changePasswordForm.get('oldPassword')?.touched" class="errorMsgForm">
        {{ getPasswordErrorMessage(changePasswordForm.get('oldPassword')!) }}
      </div>
    </mat-form-field>

    <div class="row">
      <mat-form-field class="col-12">
        <mat-label>
          {{lang =='en' ? 'New Password':'كلمة المرور الجديدة '}}
        </mat-label>
        <input matInput title="New Password" type="password" formControlName="newPassword" autocomplete="new-password">
        <div *ngIf="changePasswordForm.get('newPassword')?.invalid && changePasswordForm.get('newPassword')?.touched" class="errorMsgForm">
          {{ getPasswordErrorMessage(changePasswordForm.get('newPassword')!, lang) }}
        </div>
      </mat-form-field>

      <mat-form-field class="col-12">
        <mat-label>
          {{lang == 'en' ?'Confirm Password':'تأكيد كلمة المرور '}}
        </mat-label>
        <input matInput title="Confirm Password" type="password" formControlName="confirmPassword" autocomplete="new-password">
        <div *ngIf="changePasswordForm.errors && (changePasswordForm.get('confirmPassword')?.touched || changePasswordForm.get('password')?.touched)" class="errorMsgForm">
          {{lang === 'en' ? 'Password does not match.' : '.كلمة السر غير متطابقة'}}
        </div>
      </mat-form-field>
    </div>

    <button
      (click)="onChangePassword()"
      class="submitBtn"
      mat-raised-button
      color="primary"
      [disabled]="isLoading"
    >                                 
    <mat-spinner
      *ngIf="isLoading"
      diameter="20"
      color="primary"
    ></mat-spinner>
      <span *ngIf="!isLoading">
        {{lang == 'en' ? 'Change Password':'تغير كلمة المرور'}}
      </span>
    </button>
  </mat-expansion-panel>
</form>
